var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 24.96C5.19922 18.0675 10.7867 12.48 17.6792 12.48H34.3192C41.2117 12.48 46.7992 18.0675 46.7992 24.96V39.52H17.6792C10.7867 39.52 5.19922 33.9325 5.19922 27.04V24.96Z",
    fill: "#50A4DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35938 25.9999C9.35938 20.8305 13.55 16.6399 18.7194 16.6399H33.2794C38.4488 16.6399 42.6394 20.8305 42.6394 25.9999C42.6394 31.1693 38.4488 35.3599 33.2794 35.3599H18.7194C13.55 35.3599 9.35938 31.1693 9.35938 25.9999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8006 25.9999C20.8006 27.1487 19.8694 28.0799 18.7206 28.0799C17.5719 28.0799 16.6406 27.1487 16.6406 25.9999C16.6406 24.8512 17.5719 23.9199 18.7206 23.9199C19.8694 23.9199 20.8006 24.8512 20.8006 25.9999Z",
    fill: "#034EA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0799 25.9999C28.0799 27.1487 27.1487 28.0799 25.9999 28.0799C24.8512 28.0799 23.9199 27.1487 23.9199 25.9999C23.9199 24.8512 24.8512 23.9199 25.9999 23.9199C27.1487 23.9199 28.0799 24.8512 28.0799 25.9999Z",
    fill: "#034EA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3592 25.9999C35.3592 27.1487 34.428 28.0799 33.2792 28.0799C32.1305 28.0799 31.1992 27.1487 31.1992 25.9999C31.1992 24.8512 32.1305 23.9199 33.2792 23.9199C34.428 23.9199 35.3592 24.8512 35.3592 25.9999Z",
    fill: "#034EA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9389 13.0133C13.0773 11.521 13.5886 9.61284 15.0809 8.75128C16.5732 7.88971 18.4813 8.40101 19.3429 9.89328L23.5029 17.0986C24.3645 18.5909 23.8532 20.499 22.3609 21.3606C20.8686 22.2222 18.9605 21.7109 18.0989 20.2186L13.9389 13.0133Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0611 13.0133C38.9227 11.521 38.4114 9.61284 36.9191 8.75128C35.4268 7.88971 33.5187 8.40101 32.6571 9.89328L28.4971 17.0986C27.6355 18.5909 28.1468 20.499 29.6391 21.3606C31.1314 22.2222 33.0395 21.7109 33.9011 20.2186L38.0611 13.0133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.fa12290a3cb7ab296cffc8185ab1d3d1.svg";
export { ForwardRef as ReactComponent };